// AUDIO SE PUEDE BORRAR ESTE ARCHIVO SI NO QUEREMOS USAR EL AUDIO DE SCAN

const SCAN_BEEP_FREQUENCY = 900
const SCAN_BEEP_DURATION = 0.13
const SCAN_BEEP_VOLUME = 0.16

let scanAudioContext = null

const getAudioContext = () => {
  if (typeof window === 'undefined') return null

  const AudioContext = window.AudioContext || window.webkitAudioContext
  if (!AudioContext) return null

  if (!scanAudioContext || scanAudioContext.state === 'closed') {
    scanAudioContext = new AudioContext()
  }

  return scanAudioContext
}

export const prepareScanBeep = () => {
  const audioContext = getAudioContext()

  if (audioContext?.state === 'suspended') {
    audioContext.resume().catch(() => {})
  }
}

export const playScanBeep = () => {
  const audioContext = getAudioContext()
  if (!audioContext) return

  const playTone = () => {
    const startedAt = audioContext.currentTime
    const oscillator = audioContext.createOscillator()
    const gain = audioContext.createGain()

    oscillator.type = 'square'
    oscillator.frequency.setValueAtTime(SCAN_BEEP_FREQUENCY, startedAt)
    gain.gain.setValueAtTime(0.001, startedAt)
    gain.gain.exponentialRampToValueAtTime(SCAN_BEEP_VOLUME, startedAt + 0.01)
    gain.gain.exponentialRampToValueAtTime(0.001, startedAt + SCAN_BEEP_DURATION)

    oscillator.connect(gain)
    gain.connect(audioContext.destination)

    oscillator.start(startedAt)
    oscillator.stop(startedAt + SCAN_BEEP_DURATION)
    oscillator.onended = () => {
      oscillator.disconnect()
      gain.disconnect()
    }
  }

  if (audioContext.state === 'suspended') {
    audioContext
      .resume()
      .then(playTone)
      .catch(() => {})
    return
  }

  playTone()
}
